import { f as j, a as p } from "./cleave-react-node-c4a374e5.js";
import "@emotion/react";
import { j as b } from "./jsx-runtime-944c88e2.js";
import { u as N } from "./index-feffa1ce.js";
import { useState as S, useEffect as x, useRef as O, useCallback as w } from "react";
var k = j(function(r, e) {
  const { htmlWidth: o, htmlHeight: n, alt: s, ...l } = r;
  return /* @__PURE__ */ b.jsx("img", { width: o, height: n, ref: e, alt: s, ...l });
});
k.displayName = "NativeImage";
function y(t) {
  const {
    loading: r,
    src: e,
    srcSet: o,
    onLoad: n,
    onError: s,
    crossOrigin: l,
    sizes: d,
    ignoreFallback: u
  } = t, [c, g] = S("pending");
  x(() => {
    g(e ? "loading" : "pending");
  }, [e]);
  const i = O(), h = w(() => {
    if (!e)
      return;
    f();
    const a = new Image();
    a.src = e, l && (a.crossOrigin = l), o && (a.srcset = o), d && (a.sizes = d), r && (a.loading = r), a.onload = (m) => {
      f(), g("loaded"), n == null || n(m);
    }, a.onerror = (m) => {
      f(), g("failed"), s == null || s(m);
    }, i.current = a;
  }, [e, l, o, d, n, s, r]), f = () => {
    i.current && (i.current.onload = null, i.current.onerror = null, i.current = null);
  };
  return N(() => {
    if (!u)
      return c === "loading" && h(), () => {
        f();
      };
  }, [c, h, u]), u ? "loaded" : c;
}
var L = (t, r) => t !== "loaded" && r === "beforeLoadOrError" || t === "failed" && r === "onError";
function R(t, r = []) {
  const e = Object.assign({}, t);
  for (const o of r)
    o in e && delete e[o];
  return e;
}
var z = j(function(r, e) {
  const {
    fallbackSrc: o,
    fallback: n,
    src: s,
    srcSet: l,
    align: d,
    fit: u,
    loading: c,
    ignoreFallback: g,
    crossOrigin: i,
    fallbackStrategy: h = "beforeLoadOrError",
    referrerPolicy: f,
    ...a
  } = r, m = o !== void 0 || n !== void 0, I = c != null || // use can opt out of fallback image
  g || // if the user doesn't provide any kind of fallback we should ignore it
  !m, E = y({
    ...r,
    crossOrigin: i,
    ignoreFallback: I
  }), F = L(E, h), v = {
    ref: e,
    objectFit: u,
    objectPosition: d,
    ...I ? a : R(a, ["onError", "onLoad"])
  };
  return F ? n || /* @__PURE__ */ b.jsx(
    p.img,
    {
      as: k,
      className: "chakra-image__placeholder",
      src: o,
      ...v
    }
  ) : /* @__PURE__ */ b.jsx(
    p.img,
    {
      as: k,
      src: s,
      srcSet: l,
      crossOrigin: i,
      loading: c,
      referrerPolicy: f,
      className: "chakra-image",
      ...v
    }
  );
});
z.displayName = "Image";
export {
  z as I
};
